import { useQuery } from '@tanstack/react-query'
import { useMyAbstractAccountAddress } from 'hooks/useAbstractAccountAddress'
import { useBaseReads } from 'use-towns-client'

export function useHasMemberNftInAbstractAccount({ spaceId }: { spaceId: string | undefined }) {
    const { spaceDapp } = useBaseReads()
    const { data: abstractAccountAddress } = useMyAbstractAccountAddress()

    return useQuery({
        queryKey: ['membershipNftInSmartAccount', spaceId],
        queryFn: () => {
            if (!spaceId || !spaceDapp || !abstractAccountAddress) {
                return
            }
            const space = spaceDapp.getSpace(spaceId)
            return space?.getMembershipStatus([abstractAccountAddress])
        },
        staleTime: Infinity,
        refetchOnMount: true,
        enabled: !!spaceId && !!spaceDapp && !!abstractAccountAddress,
    })
}
